import { useState, useEffect } from 'react';

import ExtendableTable from '@/components/ExtendableTable';
import InlineEdit from '@/components/InlineEdit';
import { DETAIL_MODE, DETAIL_TYPE, useDetailMode } from '@/hooks/useDetailMode';
import { apiService } from '@/lib/axios';

const ReferencesView = ({ document, setDocument }) => {
  const { mode } = useDetailMode(DETAIL_TYPE.DOCUMENT);
  const [releasedDocs, setReleasedDocs] = useState([]);

  useEffect(() => {
    apiService.documents.getAll({ status: 'RELEASED', limit: 100 }).then((res) => {
      if (res.data.success) {
        setReleasedDocs(res.data.data);
      }
    });
  }, []);

  const options = [
    ...releasedDocs.map((doc) => ({
      label: doc.serial || doc.id,
      title: doc.title,
      value: doc.serial || doc.id,
    })),
    { label: 'Other', title: '', value: 'others' },
  ];

  const handleChange = (value) => {
    setDocument({ ...document, references: value });
  };

  return (
    <div className="space-y-4">
      <ExtendableTable
        columns={[
          {
            className: 'w-2/5',
            label: 'Document Number',
            name: 'number',
            renderField: ({ onChange, value }, _, fieldValue) =>
              fieldValue['number'] === 'others' ? (
                <>
                  {mode !== DETAIL_MODE.STATIC ? (
                    <InlineEdit
                      onChange={onChange}
                      placeholder="Enter External Doc ID"
                      value={value}
                    />
                  ) : (
                    value
                  )}
                </>
              ) : (
                <>
                  {mode !== DETAIL_MODE.STATIC ? (
                    <InlineEdit
                      onChange={onChange}
                      options={options}
                      placeholder="Select Document Number"
                      type="select"
                      value={value}
                    />
                  ) : (
                    value
                  )}
                </>
              ),
          },
          {
            label: 'Document Title',
            name: 'title',
            renderField: ({ onChange, value }, _, fieldValue) => {
              const knownDoc = releasedDocs.find(
                (d) => (d.serial || d.id) === fieldValue['number']
              );
              return knownDoc ? (
                knownDoc.title
              ) : (
                <>
                  {mode !== DETAIL_MODE.STATIC ? (
                    <InlineEdit
                      onChange={onChange}
                      placeholder="Enter Custom Title"
                      value={value}
                    />
                  ) : (
                    value
                  )}
                </>
              );
            },
          },
        ]}
        onChange={handleChange}
        mode={mode}
        value={document['references']}
      />
    </div>
  );
};

export default ReferencesView;
